import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { StelaBreadcrumbItem } from '../../models/stela-layout.models';
import { StelaBreadcrumbsComponent } from '../stela-breadcrumbs/stela-breadcrumbs.component';

@Component({
  selector: 'stela-page-head',
  standalone: true,
  imports: [NgTemplateOutlet, StelaBreadcrumbsComponent],
  templateUrl: './stela-page-head.component.html',
  styleUrl: './stela-page-head.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StelaPageHeadComponent {
  readonly title = input.required<string>();
  readonly breadcrumbs = input<StelaBreadcrumbItem[]>([]);
  readonly actionsTemplate = input<TemplateRef<unknown> | null>(null);
  /** Optional one-line metadata shown beneath the title (stats, summary, …). */
  readonly metadata = input<string | null>(null);
  /** Optional KPI strip rendered below the title row. */
  readonly kpisTemplate = input<TemplateRef<unknown> | null>(null);
  /** Optional filter-chips strip rendered below the KPI row. */
  readonly chipsTemplate = input<TemplateRef<unknown> | null>(null);
}
